export default __webpack_public_path__ + "static/life-grid-gray-min-f9bcde655597a9646c52ea2ee8521917.png";